import { render, staticRenderFns } from "./ForwardMessageToTargetActionSetupView.vue?vue&type=template&id=235d0475&scoped=true&"
import script from "./ForwardMessageToTargetActionSetupView.vue?vue&type=script&lang=ts&"
export * from "./ForwardMessageToTargetActionSetupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235d0475",
  null
  
)

export default component.exports